<div
	class="rx-intuitive-attachments-root"
	*ngIf="rxIntuitiveAttachmentsSectionVisibility$ | async as vis"
	[class.rx-intuitive-attachments-root--card-hidden]="vis === Visibility.Invisible"
>
	<tlk-card
		*ngIf="vis !== Visibility.Invisible"
		class="attachments-list-card"
		[padding]="24"
		id="attachments-section"
	>
		<h3 tlkCardHeader>
			{{ 'AttachmentsSection.Attachments' | translate }}
		</h3>
		<div tlkCardContent class="attachments-list-body">
			<rx-intuitive-attachments-replacement *ngIf="vis === Visibility.ShowReplacement"></rx-intuitive-attachments-replacement>

			<rx-intuitive-attachments-panel
				*ngIf="vis === Visibility.ShowAttachments"
				[attachmentsRxId$]="attachmentsRxId$"
				[companyId$]="companyId$"
				[isAttachmentsReadOnly$]="isAttachmentsReadOnly$"
				[biSessionInfo$]="biSessionInfo$"
				[contactId$]="contactId$"
				[userRole$]="userRole$"
				[procedureMap$]="procedureMap$"
				[patientGuid$]="patientGuid$"
				[featureToggles$]="featureToggles$"
				[companySoftwareOptions$]="companySoftwareOptions$"
				[timberUrl$]="timberUrl$"
				(isSafeToClose)="isSafeToCloseUpdated($event)"
				(attachmentsListUpdated)="onAttachmentsListUpdated()"
			></rx-intuitive-attachments-panel>
		</div>
	</tlk-card>
</div>
